const LOAD_WORKSHOP_DATA = 'LOAD_WORKSHOP_DATA'
const AUTH_AUTOCARE = 'AUTH_AUTOCARE'

const INITIAL_STATE = {
  address: "",
  lat: "",
  lon: "",
  token: "",
  defaultAdvisorEmail: "",
  callmeEmail: '',
  footer: '',
  phone: '',
  limitHour: ''
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_WORKSHOP_DATA:
      return {
        ...state,
        address: action.payload.address,
        lat: action.payload.coordinates ? action.payload.coordinates[0] : "",
        lon: action.payload.coordinates ? action.payload.coordinates[1] : "",
        holidays: action.payload.holidays,
        defaultAdvisorEmail: action.payload.defaultAdvisorEmail,
        callmeEmail: action.payload.callmeEmail,
        footer: action.payload.footer,
        phone: action.payload.phone,
        limitHour: action.payload.limitHour
      };
    case AUTH_AUTOCARE:
      return {
        ...state,
        token: action.payload.token
      };
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/workshop/reducer.js